angular.module('autoremind.reports.communication', [])
    .directive('reportsCommunicationSalesMessaging', ['$rootScope', '$location', '$log', 'dialogs', 'logger', 'userProfile', 'messagesService', 'jobService', 'todoService', 'reportConfig', '$routeParams', '$interval', '$filter',
    function ($rootScope, $location, $log, dialogs, logger, userProfile, messagesService, jobService, todoService, reportConfig, $routeParams, $interval, $filter) {
        return {
            templateUrl: 'app/reports/communication/messages/messages.html',
            scope: true,
            link: function ($scope, elem, attr) {
                console.log('$routeParams', $routeParams);
                $scope.isSelected = 'nope';
                $scope.onText = 'Y';
                $scope.offText = 'N';
                $scope.isActive = true;
                $scope.size = 'normal';
                $scope.animate = true;
                $scope.radioOff = true;
                $scope.handleWidth = "auto";
                $scope.labelWidth = "auto";
                $scope.inverse = true;
                $scope.message = {
                    error: false,
                    msg: 'Message Not Found!'
                };
                $scope.messageReportType = $location.search()['type'] || null;
                $scope.$watch('isSelected', function () {
                    $log.info('Selection changed.');
                });
                $scope.toggle = function () {
                    $scope.isSelected = $scope.isSelected === 'yep' ? 'nope' : 'yep';
                };
                $scope.setUndefined = function () {
                    $scope.isSelected = undefined;
                };
                $scope.toggleActivation = function () {
                    $scope.isActive = !$scope.isActive;
                };
                $scope.viewModel = {};
                $scope.updateTick = 0;
                $log.info('In autoremind.reports.ScreenController');
                $scope.today = new Date(); // This is also updated on every update loop
                $scope.updateCount = 0; // Debug only
                userProfile.initalizeViewModel();
                if (!angular.isDefined(userProfile.viewModel.views.reports)) {
                    userProfile.viewModel.views.reports = {};
                    userProfile.viewModel.views.reports.selectedFilter = null;
                }
                // Map shared model to scope for local reference
                $scope.viewModel = userProfile.viewModel.views.reports;
                $scope.viewModel.viewMessages = false;
                $scope.viewModel.delivery = false;
                $scope.viewModel.loadingIndicator = 0;
                $scope.viewModel.voiceDelivered = 0;
                $scope.viewModel.voiceUndelivered = 0;
                $scope.viewModel.smsDelivered = 0;
                $scope.viewModel.smsUndelivered = 0;
                $scope.viewModel.emailDelivered = 0;
                $scope.viewModel.emailUndelivered = 0;
                $scope.viewModel.messagesLastUpdate = 0;
                $scope.viewModel.loadingMessages = false;
                $scope.messages = messagesService.messages;
                $scope.messagesService = messagesService;
                $scope.gettingMessagesStats = false;
                $scope.jobService = jobService;
                jobService.job.data = null;
                $scope.job = jobService.job.data;
                $scope.viewModel.header = '_' + ($scope.messageReportType ? $scope.messageReportType : 'messaging') + '_Report_';
                $scope.print = function () {
                    var header = $filter('i18n')('_' + ($scope.messageReportType ? $scope.messageReportType : 'messaging') + '_Report_');
                    var head = angular.element(document.getElementsByTagName('head')).html();
                    var innerContents = angular.element(document.getElementById('forPrintReport')).clone();
                    // var content = document.getElementById('forPrintReport').innerHTML;
                    //innerContents.find('.removeForPrint').remove();
                    var template = '<style></style><html>' +
                        '' + head +
                        '<body class="printDialog" onload="window.print(); window.close()">' +
                        '' + innerContents.html() + '' +
                        '</body>' +
                        '</html>';
                    var popupWindow = window.open('Print of the table', '_blank', 'width=600,height=700,scrollbars=yes,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
                    popupWindow.document.open();
                    popupWindow.document.write(template);
                    popupWindow.document.close();
                };
                // Default is to show overview of different report types
                // 1: load job if not loaded
                // 2: load stats
                // 3: load messages 100 and more on scroll until total is reached
                // 4. on update if scrolled to max and total reached and stats show more then load more messages? perhaps not user friendly to automate this?
                // 5: on update if total messages already loaded then load only modified messages (split into 100 and then get next 100, etc.)
                // Consider building functionality into message table as directive?
                $scope.ensureJobLoaded = function () {
                    if ($scope.jobId !== undefined) {
                        $log.info('Opening selected job : ' + $scope.jobId);
                        jobService.job.getJobReport($scope.jobId)
                            .then(function (data) {
                            if (angular.isDefined(data.isCanceled) && data.isCanceled) {
                                return;
                            }
                            $scope.message.error = false;
                            $scope.job = jobService.job.data;
                            if ($scope.job.jobContent.targetStats !== undefined) {
                                $log.info('Expected messages : ' + $scope.job.jobContent.targetStats.totalMessages);
                            }
                            $scope.getMessagesStats();
                            if ($scope.job.jobCategory === 'latepayment') {
                                $scope.viewMessages();
                            }
                        }, function () {
                            if ($scope.updateInterval) {
                                $interval.cancel($scope.updateInterval);
                            }
                            console.log('this is error. ');
                            $scope.message.error = true;
                        });
                    }
                };
                $scope.showReportIcons = function () {
                    $scope.report = 0;
                    $scope.todo = false;
                    $scope.jobId = undefined;
                    $location.path('/reports/').search('');
                };
                $scope.openJobBrowser = function () {
                    $log.info('In autoremind.reports.ScreenController.openJobBrowser() ');
                    $scope.browserOpen = true;
                    var dialog = dialogs.create('app/communication/communications.select.job.html', 'autoremind.communications.BrowseJobController', { communicationsCategory: { communicationsCategoryId: $scope.messageReportType }, jobs: jobService.jobs }, { key: false, back: 'static' });
                    dialog.result
                        .then(function (jobId) {
                        $scope.browserOpen = false;
                        $log.info('View report for: ' + jobId);
                        if (jobId !== undefined) {
                            $scope.openJob(jobId);
                        }
                    }, function () {
                        $scope.browserOpen = false;
                    });
                };
                $scope.checkJobsExistance = function () {
                    $scope.viewModel.loadingIndicator = 1;
                    jobService.jobs.getJobs($scope.messageReportType)
                        .then(function (data) {
                        $scope.viewModel.loadingIndicator = 0;
                        if (data.jobs.length === 1 && angular.isDefined(data.jobs[0].jobId)) {
                            $scope.openJob(data.jobs[0].jobId);
                        }
                    }, function () {
                        $scope.viewModel.loadingIndicator = 0;
                    });
                };
                $scope.openJob = function (jobId) {
                    var search = { jobid: jobId };
                    if ($scope.messageReportType) {
                        search.type = $scope.messageReportType;
                    }
                    $location.search(search);
                };
                /**
                 * Filter that returns the class name suitable for the size of the number.
                 * If less than 4 digits then use biggest font, 5 digits then use medium and more digits then use smallest
                 */
                $scope.getDigitsClass = function (value) {
                    if (value < 1000)
                        return 'big-numbers';
                    if (value < 10000 && value >= 1000)
                        return 'medium-numbers';
                    if (value > 10000)
                        return 'small-numbers';
                };
                $scope.totalDeliveryChart = {};
                $scope.perMediaDeliveryChart = {};
                $scope.updateCharts = function () {
                    $scope.totalDeliveryChart = {
                        type: "PieChart",
                        displayed: true,
                        /*"cssStyle": "height:200px; width:320px; margin-bottom: 10px;",*/
                        cssStyle: "margin-top: 10px;",
                        data: [
                            ['Label', 'Data'],
                            ['Delivered', $scope.viewModel.totalDelivered],
                            ['Not Delivered', $scope.viewModel.totalMessages - $scope.viewModel.totalDelivered]
                        ],
                        options: {
                            title: "Delivered Messages",
                            height: 220,
                            chartArea: { 'left': 20, 'top': 20, 'right': 0, 'bottom': 0 },
                            pieSliceText: 'value',
                            legend: 'right',
                            displayExactValues: true,
                            colors: ['#5cb85c', '#bfc2eb', '#3B80A4'],
                            is3D: "false",
                            hAxis: {
                                title: ""
                            }
                        }
                    };
                    $scope.perMediaDeliveryChart = {
                        type: "ColumnChart",
                        displayed: true,
                        cssStyle: "height:100%; width:100%; margin-bottom: 0px",
                        data: [
                            ['Label', ''],
                            ['Text', $scope.viewModel.smsDelivered],
                            ['Email', $scope.viewModel.emailDelivered],
                            ['Calls', $scope.viewModel.voiceDelivered]
                        ],
                        options: {
                            title: "Delivered per media",
                            height: 220,
                            width: 350,
                            isStacked: "true",
                            fill: 20,
                            legend: 'none',
                            displayExactValues: true,
                            colors: ['#3B80A4', '#4D9EC9', '#6EB3D4', '#92C6E0', '#B7DBEA'],
                            is3D: "false",
                            vAxis: {
                                title: ""
                            },
                            hAxis: {
                                title: ""
                            }
                        }
                    };
                };
                $scope.viewMessagesStats = function (stats) {
                    //TODO: where to store number opened in database???
                    $scope.viewModel.messagesStats = stats;
                    if ($scope.job.jobContent.targetStats !== undefined) {
                        $scope.viewModel.totalExpected = $scope.job.jobContent.targetStats.totalMessages;
                        $scope.viewModel.totalPeople = $scope.job.jobContent.targetStats.totalPeople;
                    }
                    else
                        $scope.viewModel.totalExpected = 300;
                    //TODO: Remove 300
                    $scope.viewModel.totalMessages = stats.total;
                    // NOTE: totalPeople is the full target group - totalPeopleSent is those with selected media that we've attempted to send to
                    // In case people reached is higher than sent then set sent to that
                    $scope.viewModel.totalPeopleSent = stats.totalPeopleSent;
                    $scope.viewModel.numberOfPeopleReached = stats.numberOfPeopleReached;
                    if ($scope.viewModel.numberOfPeopleReached > $scope.viewModel.totalPeopleSent) {
                        $scope.viewModel.totalPeopleSent = $scope.viewModel.numberOfPeopleReached;
                    }
                    $scope.viewModel.targetReachedPct = 100 * $scope.viewModel.numberOfPeopleReached / $scope.viewModel.totalPeopleSent;
                    // If we dispatched more than expected then update the expected number to fit actual dispatched
                    if ($scope.viewModel.totalMessages > $scope.viewModel.totalExpected) {
                        $scope.viewModel.totalExpected = $scope.viewModel.totalMessages;
                    }
                    $scope.viewModel.totalExpectedPct = 100 * $scope.viewModel.totalMessages / $scope.viewModel.totalExpected;
                    // Delay showing delivery (and messages button) 3 seconds after job state is dequeued or sent
                    if (!$scope.viewModel.delivery && ($scope.job.jobState === 'dequeued' || $scope.job.jobState === 'sent' || $scope.job.jobState === 'failed')) {
                        var delay = 3000;
                        if ($scope.job.jobState === 'sent' || $scope.job.jobState === 'failed')
                            delay = 500;
                        setTimeout(function () {
                            $scope.viewModel.delivery = true;
                        }, delay);
                    }
                    $scope.viewModel.totalDelivered = stats.emailDelivered + stats.voiceDelivered + stats.smsDelivered;
                    $scope.viewModel.totalFailed = stats.emailFailed + stats.voiceFailed + stats.smsFailed;
                    $scope.viewModel.messagesDeliveredPct = 100 * ($scope.viewModel.totalDelivered + $scope.viewModel.totalFailed) / $scope.viewModel.totalMessages;
                    $scope.viewModel.messagesFailedPct = 100 * $scope.viewModel.totalFailed / $scope.viewModel.totalMessages;
                    $scope.viewModel.totalOpened = 0;
                    //$scope.viewModel.messagesOpenedPct = $scope.viewModel.totalDelivered / $scope.viewModel.totalMessages;
                    $scope.viewModel.emailTotal = stats.emailTotal;
                    $scope.viewModel.emailDelivered = stats.emailDelivered;
                    $scope.viewModel.emailDeliveredPct = 100 * stats.emailDelivered / stats.emailTotal;
                    $scope.viewModel.emailUndelivered = stats.emailUndelivered; // - stats.emailFailed;
                    $scope.viewModel.emailUndeliveredPct = 100 * stats.emailUndelivered / stats.emailTotal;
                    $scope.viewModel.emailFailed = stats.emailFailed;
                    $scope.viewModel.emailFailedPct = 100 * stats.emailFailed / stats.emailTotal;
                    $scope.viewModel.emailOpened = stats.emailOpened;
                    $scope.viewModel.emailOpenedPct = 100 * stats.emailOpened / stats.emailTotal;
                    $scope.viewModel.percentage = stats.totalAble / stats.totalPeople * 100;
                    $scope.viewModel.voiceTotal = stats.voiceTotal;
                    $scope.viewModel.voiceDelivered = stats.voiceDelivered;
                    $scope.viewModel.voiceDeliveredPct = 100 * stats.voiceDelivered / stats.voiceTotal;
                    $scope.viewModel.voiceUndelivered = stats.voiceUndelivered; // - stats.voiceFailed;
                    $scope.viewModel.voiceUndeliveredPct = 100 * stats.voiceUndelivered / stats.voiceTotal;
                    $scope.viewModel.voiceFailed = stats.voiceFailed;
                    $scope.viewModel.voiceFailedPct = 100 * stats.voiceFailed / stats.voiceTotal;
                    $scope.viewModel.smsTotal = stats.smsTotal;
                    $scope.viewModel.smsDelivered = stats.smsDelivered;
                    $scope.viewModel.smsDeliveredPct = 100 * stats.smsDelivered / stats.smsTotal;
                    $scope.viewModel.smsUndelivered = stats.smsUndelivered;
                    $scope.viewModel.smsUndeliveredPct = 100 * stats.smsUndelivered / stats.smsTotal;
                    $scope.viewModel.smsFailed = stats.smsFailed;
                    $scope.viewModel.smsFailedPct = 100 * stats.smsFailed / stats.smsTotal;
                    $scope.updateCharts();
                };
                $scope.getMessagesStats = function () {
                    if ($scope.jobId === undefined)
                        return;
                    $scope.gettingMessagesStats = true;
                    $scope.viewModel.loadingIndicator++;
                    messagesService.getMessagesStatsByJobId($scope.jobId)
                        .then(function (messagesStats) {
                        $scope.viewModel.stats = messagesStats.stats;
                        $scope.viewMessagesStats($scope.viewModel.stats);
                        if ($scope.viewModel.loadingIndicator > 0)
                            $scope.viewModel.loadingIndicator--;
                        //TODO: add timestamp to request - keep one for job data and one for messages
                    }, function (data, status, statusText) {
                        logger.error('Error getting stats from server' + status + ' ' + data + ' ' + statusText);
                        if ($scope.viewModel.loadingIndicator > 0)
                            $scope.viewModel.loadingIndicator--;
                        $scope.gettingMessagesStats = false;
                    });
                };
                //             NOTE: Event generated by ProgressBarController
                $scope.updateInterval = $interval(function () {
                    if ($scope.report > 0 && $scope.jobId !== undefined && !$scope.browserOpen && !messagesService.inProgress) {
                        console.log('updateTick');
                        $scope.today = new Date(); // Updating date of report
                        $scope.updateCount++; // Debug only
                        $scope.ensureJobLoaded();
                        //$scope.getMessagesStats();
                    }
                    else {
                        console.log('updateTick skipped due to messageService in progress');
                    }
                }, 5000);
                $scope.$on('$destroy', function () {
                    if ($scope.updateInterval) {
                        $interval.cancel($scope.updateInterval);
                    }
                });
                $scope.viewMessages = function () {
                    $scope.viewModel.viewMessages = true;
                };
                $scope.jobStatusLabel = function (state) {
                    if (state === 'draft')
                        return 'Draft - not completed yet by user';
                    else if (state === 'queued' || state === 'dequeued')
                        return 'In progress - messages will be sent soon'; // TODO: This should be different depending on whether automated or not
                    else if (state === 'sent')
                        return 'Done - all messages sent (failed may be retried)';
                    else if (state === 'disabled')
                        return 'Disabled';
                    else
                        return '';
                };
                if (angular.isDefined($routeParams.jobid)) {
                    $scope.jobId = $routeParams.jobid;
                    $scope.ensureJobLoaded();
                }
                else if ($scope.messageReportType && $scope.messageReportType === 'birthday') {
                    $scope.checkJobsExistance();
                }
                $rootScope.$on('event:auth-logout', function () {
                    if ($scope.updateInterval) {
                        $interval.cancel($scope.updateInterval);
                    }
                });
                $rootScope.$on('event:auth-loginConfirmed', function () {
                    $location.search('jobid', null);
                });
            }
        };
    }]);
//# sourceMappingURL=messages.directive.js.map